import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions';
import mutations from './mutations';
import state from './state';
import getters from './getters';
import settings from './modules/settings';
import EmailTemplates from "./modules/EmailTemplates";
import products from "./modules/Products";
import container from "./modules/Container";
import auth from  "./modules/auth";
import priceList from "./modules/priceList";
import sharepoint from "./modules/sharepoint";
import billing from "./modules/billing"
import designCategory from "./modules/designCategory";


Vue.use(Vuex)

export default new Vuex.Store({
  strict: (process.env.NODE_ENV != 'production'),
  state,
  mutations,
  actions,
  getters,
  modules: {
    settings,
    EmailTemplates,
    products,
    container,
    auth,
    priceList,
    sharepoint,
    billing,
    designCategory
  }
})
